// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__2SGmi","icon":"search_icon__3qSLq","input":"search_input__2ptW0","button":"search_button__3qm2f"};